<script setup>
import { ref } from 'vue';
import TwoFactor from './TwoFactor.vue';

const props = defineProps({
  qrCodeSvg: {
    type: String,
    required: true,
  },
  secret: {
    type: String,
    required: true,
  },
  verifyCode: {
    type: Function,
    required: true,
  },
});

const twoFactorCodeRef = ref(null);

defineExpose({ twoFactorCodeRef });
</script>

<template>
  <div class="two-factor-auth">
    <h4>Two-Factor Authentication Setup</h4>
    <div class="qr-code-section">
      <div v-html="props.qrCodeSvg"></div>
      <p style="margin-top: 10px">
        Scan this QR code with your authentication app.
      </p>
    </div>
    <div class="manual-key-section">
      <p>Alternatively, you can enter this key manually:</p>
      <code>{{ props.secret }}</code>
    </div>
    <div class="verification-section">
      <p>Enter the generated code to verify and finish setup:</p>
      <two-factor ref="twoFactorCodeRef" @submit="props.verifyCode" />
    </div>
  </div>
</template>

<style scoped>
.two-factor-auth {
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.qr-code-section img {
  width: 150px;
  height: 150px;
}

.manual-key-section code {
  display: block;
  margin: 10px 0;
  padding: 10px;
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  font-family: monospace;
  font-size: 20px;
}

.verification-section input {
  margin: 10px 0;
  padding: 10px;
  width: calc(100% - 20px);
}

.verification-section button {
  padding: 10px 20px;
}

.error-message {
  color: red;
  margin-top: 10px;
}
</style>
